import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    caratula: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_CARATULAS = 'GET_ALL_CARATULAS'
const GET_CARATULA_BY_ID = 'GET_CARATULA_BY_ID'
const GET_CARATULA_BY_ID_INFORME = 'GET_CARATULA_BY_ID_INFORME'
const POST_CARATULA = 'POST_CARATULA'
const UPDATE_CARATULA = 'UPDATE_CARATULA'
const DELETE_CARATULA = 'DELETE_CARATULA'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllCaratulas = createAsyncThunk(
    GET_ALL_CARATULAS,
    async () => {
        try {
            const fullUrl = host + `Fi25Caratula/obtenerCaratulas`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las Caratulas: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getCaratulaById = createAsyncThunk(
    GET_CARATULA_BY_ID,
    async (idCaratula) => {
        try {
            const fullUrl = host + `Fi25Caratula/obtenerCaratulaById/${idCaratula}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getCaratulaByIdInforme = createAsyncThunk(
    GET_CARATULA_BY_ID,
    async (idInforme) => {
        try {
            const fullUrl = host + `Fi25Caratula/obtenerCaratulaByIdInforme/${idInforme}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertCaratula = createAsyncThunk(
    POST_CARATULA,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Caratula/agregarCaratula`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateCaratula = createAsyncThunk(
    UPDATE_CARATULA,
    async (data) => {
        try {
            const fullUrl = host + `Fi25Caratula/actualizarCaratula`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteCaratula = createAsyncThunk(
    DELETE_CARATULA,
    async (idCaratula) => {
        try {
            const fullUrl = host + `Fi25Caratula/eliminarCaratula/${idCaratula}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosCaratulaSlice = createSlice({

    name: 'metodosCaratulaSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllCaratulas.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.caratula = payload.data.data

        },
        [getCaratulaById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.caratula = payload.data.data
        },
        [getCaratulaByIdInforme.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.caratula = payload.data.data
        },
        [insertCaratula.fulfilled]: (state, { payload }) => {
            state.caratula = payload.data.data
        },

        [updateCaratula.fulfilled]: (state, { payload }) => {

        },
        [deleteCaratula.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosCaratulaSlice.actions
export const CaratulaReducer = metodosCaratulaSlice.reducer